import { render, staticRenderFns } from "./expireCourse.vue?vue&type=template&id=32e7cdf6&scoped=true&"
import script from "./expireCourse.vue?vue&type=script&lang=js&"
export * from "./expireCourse.vue?vue&type=script&lang=js&"
import style0 from "./expireCourse.vue?vue&type=style&index=0&id=32e7cdf6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e7cdf6",
  null
  
)

export default component.exports